import React from 'react';
import WangEditor from '../../../../components/WangEditor';

import './index.less';

interface IProps {
  answer: string | string[];
  disabled?: boolean;
  onBlurEditor?:(value:any)=>void;
}

function AnswerOption({answer,disabled=true,onBlurEditor} : IProps) {
  
  return (
    <div className="manmade-answer-option">
      <WangEditor  initData={answer} disabled={disabled} onBlurEditor={onBlurEditor}/>
    </div>
  )
}

export default AnswerOption;
